import { FC } from 'react'
import { useLocation } from 'react-router-dom'
import { shouldShowIntercom } from 'src/modules/core/utils/intercom.utils'
import { IntercomChat } from 'src/modules/intercom/intercom-chat'
import classes from './general-layout.module.scss'

export const GeneralLayout: FC = ({ children }) => {
  const location = useLocation()
  const showIntercomChat = shouldShowIntercom(location.pathname)

  return (
    <>
      <IntercomChat show={showIntercomChat} />
      <div className={classes.root}>
        <div className={classes.content}>{children}</div>
      </div>
    </>
  )
}
